import type { BaseAction } from '../../types/redux';
import {
  LOGIN,
  NAV_TOGGLE,
  SAVE_PREFERENCES_STATE,
  SAVE_QUERY_SESSION,
  SAVE_TABLE_PAGESIZE,
  SAVE_TABLE_PREF,
  SET_FEATURE_FLAGS,
  SET_MFA,
  USER_LOGOUT,
} from './types';

export interface SetUserAction extends BaseAction {
  type: typeof LOGIN;
  data: Record<string, unknown>;
}

export interface SetMfaAction extends BaseAction {
  type: typeof SET_MFA;
  val: { show: boolean };
}

export interface ToggleNavAction extends BaseAction {
  type: typeof NAV_TOGGLE;
  val: string | boolean;
}

export interface ResetStateAction extends BaseAction {
  type: typeof USER_LOGOUT;
}

export interface SaveTablePrefAction extends BaseAction {
  type: typeof SAVE_TABLE_PREF;
  tableKey: string;
  data: Record<string, unknown>;
}

export interface SaveTablePageSizeAction extends BaseAction {
  type: typeof SAVE_TABLE_PAGESIZE;
  tableKey: string;
  data: Record<string, unknown>;
}

export interface SetQSessionAction extends BaseAction {
  type: typeof SAVE_QUERY_SESSION;
  data: Record<string, unknown>;
}

export interface SetPreferencesStateAction extends BaseAction {
  type: typeof SAVE_PREFERENCES_STATE;
  key: string;
  value: unknown;
}

export interface SetFeatureFlagsAction extends BaseAction {
  type: typeof SET_FEATURE_FLAGS;
  featureFlags: Record<string, unknown>;
}

export type AuthAction =
  | SetUserAction
  | SetMfaAction
  | ToggleNavAction
  | ResetStateAction
  | SaveTablePrefAction
  | SaveTablePageSizeAction
  | SetQSessionAction
  | SetPreferencesStateAction
  | SetFeatureFlagsAction;

export function setUser(data: Record<string, unknown>): SetUserAction {
  return {
    type: LOGIN,
    data: data,
  };
}

export const setMfa = (val: { show: boolean }): SetMfaAction => {
  return {
    type: SET_MFA,
    val,
  };
};

export const toggleNav = (val: string | boolean = ''): ToggleNavAction => {
  return {
    type: NAV_TOGGLE,
    val,
  };
};

export const resetState = (): ResetStateAction => {
  return {
    type: USER_LOGOUT,
  };
};

export function saveTablePref(
  tableKey: string,
  data: Record<string, unknown>
): SaveTablePrefAction {
  return {
    type: SAVE_TABLE_PREF,
    tableKey,
    data,
  };
}

export function saveTablePageSize(
  tableKey: string,
  data: Record<string, unknown>
): SaveTablePageSizeAction {
  return {
    type: SAVE_TABLE_PAGESIZE,
    tableKey,
    data,
  };
}

// session id , timestamp,port and podip
export function setQSession(data: Record<string, unknown>): SetQSessionAction {
  return {
    type: SAVE_QUERY_SESSION,
    data,
  };
}

export function setPreferencesState(key: string, value: unknown): SetPreferencesStateAction {
  return {
    type: SAVE_PREFERENCES_STATE,
    key,
    value,
  };
}

export function setFeatureFlags(featureFlags: Record<string, unknown>): SetFeatureFlagsAction {
  return {
    type: SET_FEATURE_FLAGS,
    featureFlags,
  };
}
